module.exports = __webpack_public_path__ + "static/media/pdf-svgrepo-com.d153a1d6.svg";